import request from '../utils/request'

export default {
  async list (data) {
    const ret = await request('/v1/locationLog/list', data, 'POST')
    return ret
  }
}
